import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import {setupRouter} from './router'
import store from './store'
import { VueCookieNext } from 'vue-cookie-next'
import { setupI18n } from './i18n'
import '@/assets/css/index.css'
import '@/assets/asw/vendor/bootstrap/css/bootstrap.min.css'
import '@/assets/asw/fonts/font-awesome-4.7.0/css/font-awesome.min.css'
import '@/assets/asw/fonts/iconic/css/material-design-iconic-font.min.css'
import '@/assets/asw/vendor/animate/animate.css'
import '@/assets/asw/vendor/css-hamburgers/hamburgers.min.css'
import '@/assets/asw/vendor/animsition/css/animsition.min.css'
import '@/assets/asw/vendor/select2/select2.min.css'
import '@/assets/asw/vendor/daterangepicker/daterangepicker.css'
import '@/assets/asw/css/util.css'
import '@/assets/asw/css/main.css'
import '@/assets/asw/css/style.css'                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
import axios from 'axios'
import VueAxios from 'vue-axios'

import en from './locales/en.yaml'
const i18n = setupI18n({
    globalInjection: true,
    legacy: false,
    locale: 'en',
    fallbackLocale: 'en',
    messages: {
        en
    }
  })
const router = setupRouter(i18n)
const app = createApp(App)

app
    .use(store)
    .use(VueCookieNext)
    .use(VueAxios, axios)
    .use(i18n)
    .use(router)
    .mount('#app')
VueCookieNext.config({ expire: '7d' })
VueCookieNext.setCookie('theme', 'default')


